<ngx-loading-bar [includeSpinner]="false" height="4px" color="#0ea5e9"></ngx-loading-bar>

<!-- Dashboard Modal accessible partout via Ctrl+Alt+D -->
@defer (when dashboardModalOpen(); prefetch on idle) {
    <app-dashboard-modal></app-dashboard-modal>
}

<!-- Animation et popup saisonnière -->
@defer (on idle) {
    <app-seasonal-animation></app-seasonal-animation>
}
<app-seasonal-theme-popup></app-seasonal-theme-popup>

<!-- Modal de déclaration quotidienne SIRH -->
<app-daily-declaration-modal></app-daily-declaration-modal>

<!-- Bandeau « Succès débloqué » (easter eggs, petits défis) -->
@if (achievementsEnabled) {
<app-achievement-toast />
}

<!-- Konami code : animation plein écran, chargée au premier déclenchement -->
@defer (when konami.declenchement(); prefetch on idle) {
<app-konami />
}

@if (canRenderAppContent) {
<div class="rc-app-content" [class.rc-app-content--revealed]="appContentRevealed()">
    <router-outlet></router-outlet>
</div>
}

@if (loadingScreenVisible) {
<div class="rc-loading-screen dashboard-bg"
     role="status"
     aria-live="polite"
     aria-busy="true"
     @loadingScreenTransition>
    <div class="rc-loading-panel">
        <div class="rc-loading-brand">
            <div class="rc-loading-logo-frame">
                <img [ngSrc]="loadingBrandLogo"
                     [width]="loadingBrand.width"
                     [height]="loadingBrandLogoHeight"
                     priority
                     class="rc-loading-logo"
                     [class.rc-loading-logo--rc]="loadingBrand.id === 'rc'"
                     [class.rc-loading-logo--alg]="loadingBrand.id === 'alg'"
                     [alt]="loadingBrand.name">
            </div>
        </div>

        <div class="rc-loading-copy">
            <p class="rc-loading-eyebrow">RC Platform</p>
            <h1>Préparation de votre espace</h1>
            <p>Connexion sécurisée et synchronisation de l’environnement de travail.</p>
        </div>

        <div class="rc-loading-progress" aria-hidden="true">
            <span></span>
        </div>
    </div>
</div>
}
